import React, { useState } from "react";
import { Page, Button, Modal } from "react-onsenui";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCamera, faCheck, faRedo } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import { BASE_URL } from "../apiService";
import Select from "react-select";

const CameraScreen = ({
  setFocusedExtraImageID,
  focusedExtraImageID,
  uploadType,
  docName,
  claim,
  setCapturedImage,
  uploadImage,
  setCameraModalVis,
  fetchSyncCount,
}) => {
  const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selectedStage, setSelectedStage] = useState(null);

  const stages = [
    { value: "stage1", label: "Step 1 - Constitute or Reconstitute of FRC" },
    { value: "stage2", label: "Step 2 - CFR claims filling and Maps" },
    { value: "stage3", label: "Step 3 - Joint meeting with neighbouring villages" },
    { value: "stage4", label: "Step 4 - Physical verification of CFR claim" },
    { value: "stage5", label: "Step 5 - Final Gram sabha for the submission of CFR claim" },
  ];

  const handleStageChange = (selectedOption) => {
    setSelectedStage(selectedOption);
    console.log("Selected Stage:", selectedOption);
  };

  const handleCapture = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setImage(e.target.result);
        if (typeof setCapturedImage === "function") {
          setCapturedImage(file);
        }
      };
      reader.readAsDataURL(file);
    }
  };

  const handleRetake = () => {
    setImage(null);
  };

  const handleUpload = async () => {
    if (image) {
      try {
        setLoading(true);
        const response = await fetch(image);
        const blob = await response.blob();

        const isOnline = window.navigator.onLine;
        if (isOnline) {
          const storageUrl = await uploadImage(blob);

          let extraImageIDIndex = null;
          if (uploadType === "MAIN_DOC") {
            extraImageIDIndex = null;
          } else if (uploadType === "NEW_EXTRA_IMAGE") {
            extraImageIDIndex = "NEW";
          } else if (uploadType === "UPDATE_EXTRA_IMAGE") {
            extraImageIDIndex = focusedExtraImageID;
          }

          await axios.patch(`${BASE_URL}/claims`, {
            userId: claim?.ownerId,
            claimId: claim?._id?.toString(),
            storageUrl: storageUrl,
            title: docName,
            extraImageID: extraImageIDIndex,
            selectedStage: selectedStage?.value, // Adding the selected stage
          });

          setFocusedExtraImageID(null);
        } else {
          const db = await openDB();
          const tx = db.transaction("claim-images", "readwrite");

          let extraImageIDIndex = null;
          if (uploadType === "MAIN_DOC") {
            extraImageIDIndex = null;
          } else if (uploadType === "NEW_EXTRA_IMAGE") {
            extraImageIDIndex = "NEW";
          } else if (uploadType === "UPDATE_EXTRA_IMAGE") {
            extraImageIDIndex = focusedExtraImageID;
          }

          await tx.objectStore("claim-images").add({
            blob,
            timestamp: Date.now(),
            userId: claim?.ownerId,
            claimId: claim?._id?.toString(),
            title: docName,
            extraImageID: extraImageIDIndex,
            selectedStage: selectedStage?.value, // Adding the selected stage
          });
         
          // check for timestamp of the cache
          const response=await openDB();

          console.warn(response)

          

          window.navigator.serviceWorker.ready.then((registration) => {
            registration.sync.register("sync-claim-docs");
          });
        }
        setCameraModalVis(false);
      } catch (error) {
        console.error("Upload failed:", error);
      } finally {
        setLoading(false);
        fetchSyncCount();
      }
    }
  };

  return (
    <Page >
      <div style={{ padding: "20px", textAlign: "center", background: "white", height: "100vh" }}>
        <h2 style={{ color: "#5C7232" }}>Capture Photo</h2>

        {/* Stage Selection Dropdown */}
        <div style={{ marginBottom: "20px" }}>
          <h3>Select Stage</h3>
          <Select
          isDisabled={uploadType==="UPDATE_EXTRA_IMAGE"}
            options={stages}
            value={selectedStage}
            onChange={handleStageChange}
            placeholder="Select a stage..."
          />
        </div>

        {!image ? (
          <div style={{ margin: "20px 0" }}>
            <input
              type="file"
              accept="image/*"
              capture="camera"
              onChange={handleCapture}
              style={{ display: "none" }}
              id="cameraInput"
            />
            <label htmlFor="cameraInput">
              <Button
                modifier="large"
                style={{
                  backgroundColor: "#5C7232",
                  color: "#fff",
                  borderRadius: 20,
                  marginBottom: "10px",
                }}
              >
                <FontAwesomeIcon icon={faCamera} size="lg" /> Open Camera
              </Button>
            </label>
          </div>
        ) : (
          <div style={{ margin: "20px 0"}}>
            <img
              src={image}
              alt="Captured"
              style={{ maxHeight:'300px', borderRadius: "8px" ,border:'solid 1px black' }}
            />
          </div>
        )}

        {image && (
          <>
            <Button
              modifier="large"
              onClick={handleUpload}
              style={{
                backgroundColor: "#5C7232",
                color: "#fff",
                borderRadius: 20,
              }}
            >
              <FontAwesomeIcon icon={faCheck} size="lg" /> Upload
            </Button>

            <Button
              modifier="large"
              onClick={handleRetake}
              style={{
                backgroundColor: "#5C7232",
                color: "#fff",
                borderRadius: 20,
                marginTop: "10px",
              }}
            >
              <FontAwesomeIcon icon={faRedo} size="lg" /> Retake
            </Button>
          </>
        )}
      </div>

      <Modal isOpen={loading} style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
        <div
          style={{
            background: "#5C7232",
            padding: "20px",
            borderRadius: "10px",
            width: "50%",
            marginLeft: "30%",
          }}
        >
          <div className="spinner-border" role="status" style={{ width: "3rem", height: "3rem" }}>
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      </Modal>
    </Page>
  );
};

export default CameraScreen;

// Utility function to open IndexedDB
function openDB() {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open("ClaimSyncDB", 1);
    request.onupgradeneeded = (event) => {
      const db = event.target.result;
      if (!db.objectStoreNames.contains("claim-images")) {
        db.createObjectStore("claim-images", { keyPath: "id", autoIncrement: true });
      }
    };
    request.onsuccess = () => resolve(request.result);
    request.onerror = (event) => reject(event.target.error);
  });
}
